
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 39 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.751.726a.87.87 0 00-.141-.358L38.606.36C38.6.35 38.588.345 38.58.337A.93.93 0 0038.46.2c-.024-.02-.052-.03-.077-.048a.881.881 0 00-.345-.146h-.036a.894.894 0 00-.352.028c-.025.007-.05.008-.075.017L.568 14.15a.881.881 0 00-.195 1.544l6.06 4.17 27.68-16.35-23.86 19.79-1.44 11.934c.002.339.197.647.504.793a.867.867 0 00.935-.111l8.694-7.114L30.33 36.84c.15.106.328.161.512.16.418 0 .78-.295.863-.705L38.754 1.05v-.017-.056a.862.862 0 00-.003-.25z","fill":"#111","fill-rule":"nonzero"}})])
          )
        }
      }
    